module.exports = __webpack_public_path__ + "static/media/boat-collection-filled-svgrepo-com.69a7d289.svg";